import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license-pro';
import { useNavigate } from 'react-router-dom';
import { request } from './services/api-request';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import "./i18n"

// Clear localStorage when environment changes to avoid cache issues
const ENV = (process.env.REACT_APP_ENV || 'LOCAL').toUpperCase();
const currentEnv = localStorage.getItem('currentEnvironment');
if (currentEnv && currentEnv !== ENV) {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('bearer');
}
localStorage.setItem('currentEnvironment', ENV);

// ----------------------------------------------------------------------

// Apply license key for all environments
// Note: This license key has expired. Please renew your MUI X Pro license.
LicenseInfo.setLicenseKey('52e48259284f2e5e75c57f4f301a20a7Tz04MTYxMixFPTE3MzYwNzA2NjMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

// Suppress license warnings in development mode
if (process.env.NODE_ENV === 'development') {
  // This will suppress the license warning but won't provide full functionality
  console.warn('MUI X Pro license has expired. Please renew your license for full functionality.');
}


const root = ReactDOM.createRoot(document.getElementById('root'));

// Commented out storedUser logic to avoid automatic API calls on startup
// const storedUser = JSON.parse(localStorage.getItem('user'));
// if(storedUser) {
//     const requestResult = await request('GET', WebUser/);
//     const WebUserDTO = requestResult.data;
//     if (WebUserDTO && WebUserDTO.forceReload) {
//         localStorage.removeItem('user');
//         window.location.reload();

//         WebUserDTO.ForceReload = false;
//         await request('PUT', WebUser/, WebUserDTO);
//     }
// }

root.render(<App />);

serviceWorker.unregister();

reportWebVitals();
